import { HttpClient, provideHttpClient } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  EnvironmentProviders,
  ErrorHandler,
  Provider,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { wsc } from '@ay-gosu-party/server-shared';
import {
  BASE_NAVIGATE_PATH,
  ENABLE_THIRD_PARTY_LOGIN,
  SERVICE_NAME,
} from '@ay-gosu/ui/login/login.service';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { LOGIN_SERVICE } from '../../../ui/login/login.service';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { CustomErrorHandler } from './backstage/error.handler';
import { BackstageLoginService } from './backstage/login.service';
import { materialProviders } from './providers/material';
import { sentryProviders } from './providers/sentry';
import { angularSvgIconConfig } from './providers/svg-icon';
import { ServerConfig } from './server-config';

const providers: Array<Provider | EnvironmentProviders> = [
  provideAnimationsAsync(),
  provideRouter(routes),
  provideHttpClient(),
  provideAngularSvgIcon(angularSvgIconConfig),
  { provide: ErrorHandler, useClass: CustomErrorHandler },
  ...materialProviders,
  ...sentryProviders,
  { provide: 'SERVER_URLS', useValue: environment.servers },
  { provide: 'WSC', useValue: wsc },
  { provide: SERVICE_NAME, useValue: 'GOSU' },
  { provide: ENABLE_THIRD_PARTY_LOGIN, useValue: true },

  {
    provide: APP_INITIALIZER,
    useFactory: (config: ServerConfig) => async () => await config.load(),
    deps: [ServerConfig, HttpClient],
    multi: true,
  },
  {
    provide: 'LOCAL_STORAGE_KEY',
    useFactory: (config: ServerConfig) => config.LOCAL_STORAGE_KEY,
    deps: [ServerConfig],
  },
  {
    provide: BASE_NAVIGATE_PATH,
    useValue: '/backstage',
  },
  {
    provide: LOGIN_SERVICE,
    useClass: BackstageLoginService,
  },
];

export const appConfig: ApplicationConfig = {
  providers,
};
